"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const mobx_1 = require("mobx");
class RelatedNewsStore {
    constructor(config) {
        this.listType = config.listType;
        this.items = config.items;
    }
}
tslib_1.__decorate([
    mobx_1.observable,
    tslib_1.__metadata("design:type", Array)
], RelatedNewsStore.prototype, "items", void 0);
exports.default = RelatedNewsStore;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoicmVsYXRlZE5ld3NTdG9yZS5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbInJlbGF0ZWROZXdzU3RvcmUudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7O0FBQ0EsK0JBQWtDO0FBT2xDLE1BQXFCLGdCQUFnQjtJQUdqQyxZQUFZLE1BQXlCO1FBQ2pDLElBQUksQ0FBQyxRQUFRLEdBQUcsTUFBTSxDQUFDLFFBQVEsQ0FBQztRQUNoQyxJQUFJLENBQUMsS0FBSyxHQUFHLE1BQU0sQ0FBQyxLQUFLLENBQUM7SUFDOUIsQ0FBQztDQUVKO0FBTmU7SUFBWCxpQkFBVTtzQ0FBZSxLQUFLOytDQUFrQztBQUZyRSxtQ0FRQyJ9